// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".src-components-Common-ExportButton-style__component--UD7Yi{display:flex}.src-components-Common-ExportButton-style__component--UD7Yi .src-components-Common-ExportButton-style__button--zGCuL{margin-left:8px}", "",{"version":3,"sources":["webpack://./src/components/Common/ExportButton/style.scss"],"names":[],"mappings":"AACA,4DACE,YAAA,CAEA,qHACE,eAAA","sourcesContent":["@use 'src/utils/css/variables' as *;\n.component {\n  display: flex;\n\n  .button {\n    margin-left: 8px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"lHeaderHeight": "56px",
	"lCompanyHeight": "114px",
	"h2FontSize": "28px",
	"h3FontSize": "20px",
	"bodyLineHeight": "20px",
	"lGnShrinkWindowWidth": "1591px",
	"tableVerticalPadding": "8px",
	"tableHorizontalPadding": "16px",
	"lPersonnelBreakWidth": "1599px",
	"cNavigationAccent": "#f57f17",
	"cTableBodyOdd": "#fff",
	"cTableBodyEven": "#f2f6f8",
	"cTableHover": "#c5ddeb",
	"cTableHeadOdd": "#eaf1f5",
	"cTableHeadEven": "#dee8ef",
	"zPageLoading": "2",
	"component": "src-components-Common-ExportButton-style__component--UD7Yi",
	"button": "src-components-Common-ExportButton-style__button--zGCuL"
};
export default ___CSS_LOADER_EXPORT___;
